<div class="public-cloud-logo">
    <span class="color-public-cloud icon icon-product-public-cloud icon-size-60 margin-right-10"></span>
    <div class="public-cloud-logo__title">
        <div class="line-1">Infomaniak</div>
        <div class="line-2">Public Cloud</div>
    </div>
</div>

<ng-container [ngSwitch]="step">
    <div *ngSwitchCase="'initial'"
         class="step-initial container padding-top-60 padding-bottom-60">
        <mat-card class="card shadow">
            <mat-card-content>
                <div class="block-summary padding-top-40 padding-bottom-40">
                    <div class="block-summary__header">
                        <div class="text-center block">
                            <div class="margin-bottom-40">
                                <img class="illustration-cloud-password"
                                     [src]="'/assets/images/public-cloud/public-cloud-padlock.svg'"
                                     [alt]="'Illustration creation de mot de passe' | transloco">
                            </div>
                            <div class="row justify-content-sm-center">
                                <div class="col-lg-8">
                                    <p>{{'Il est tres important de copier et conserver ce mot de passe afin de vous connecter a votre tableau de bord OpenStack' | transloco}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-buttons text-center justify-content">
                        <a mat-raised-button
                           color="primary"
                           (click)="step = 'create-password'">
                            {{ ('Creer le mot de passe' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngSwitchCase="'create-password'"
         class="step-create-password container padding-top-60 padding-bottom-60">
        <mat-card class="card shadow">
            <mat-card-content>
                <div class="block-summary padding-top-40 padding-bottom-40">
                    <div class="block-summary__header">
                        <div class="text-center block">
                            <div class="margin-bottom-40">
                                <img class="illustration-cloud-password"
                                     [src]="'/assets/images/public-cloud/public-cloud-create-password.svg'"
                                     [alt]="'Illustration mot de passe' | transloco">
                            </div>
                            <div class="row justify-content-sm-center">
                                <div class="col-lg-8">
                                    <p>{{'Creez votre mot de passe' | transloco}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <form [formGroup]="form"
                              class="form margin-top-30 margin-bottom-40">
                            <ik-password-input [iconSeePassword]="'icon-eye'"
                                               [iconHidePassword]="' icon-eye-crossed'"
                                               [iconGeneratePassword]="'icon-rotation-lock'"
                                               [classes]="'ik-form-field ik-form-field--bigger password-field'"
                                               [label]="'Mot de passe' | transloco"
                                               [minLength]="8"
                                               [showGenerate]="true"
                                               (generate)="generate($event)"
                                               formControlName="password"
                                               matInput
                                               name="password"
                                               [placeholder]="'Mot de passe' | transloco"
                                               type="text"
                                               autocomplete="password">
                            </ik-password-input>
                            <div class="margin-bottom-30 margin-top-30 validation">
                                <ik-validation-check [label]="'a'"
                                                     [description]="'Minuscule' | transloco"
                                                     [tooltipMessage]="'Au moins une minuscule' | transloco"
                                                     [valid]="passwordValidation.lowerCase">
                                </ik-validation-check>
                                <ik-validation-check [label]="'A'"
                                                     [description]="'Majuscule' | transloco"
                                                     [tooltipMessage]="'Au moins une majuscule' | transloco"
                                                     [valid]="passwordValidation.upperCase">
                                </ik-validation-check>
                                <ik-validation-check [label]="'0-9'"
                                                     [description]="'Chiffre' | transloco"
                                                     [tooltipMessage]="'Au moins un chiffre' | transloco"
                                                     [valid]="passwordValidation.number">
                                </ik-validation-check>
                                <ik-validation-check [label]="'8+'"
                                                     [description]="'Caracteres' | transloco"
                                                     [tooltipMessage]="'$number$ caracteres ou plus' | transloco:{number: 8}"
                                                     [valid]="passwordValidation.characterCount">
                                </ik-validation-check>
                            </div>
                            <mat-error *ngIf="form.get('password').hasError('maxlength')"> *
                                {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco}}
                            </mat-error>
                            <mat-error *ngIf="displayFormError"
                                       [innerHTML]="getValidationErrorMessage()"
                                       class="hintError"></mat-error>
                        </form>
                    </div>
                    <div class="block-buttons text-center justify-content">
                        <a mat-raised-button
                           color="primary"
                           [disabled]="form.invalid"
                           (click)="submitPassword()">
                            {{ ('Enregistrer' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>


    <div *ngSwitchCase="'finished'"
         class="step-finished container padding-top-60 padding-bottom-60">
        <mat-card class="card shadow">
            <mat-card-content>
                <div class="block-summary padding-top-40 padding-bottom-40">
                    <div class="block-summary__header">
                        <div class="text-center block">
                            <div class="margin-bottom-40">
                                <img class="illustration-cloud-password"
                                     [src]="'/assets/images/public-cloud/public-cloud-user-created.svg'"
                                     [alt]="'Illustration mot de passe change' | transloco">
                            </div>
                            <div class="row justify-content-sm-center">
                                <div class="col-lg-8">
                                    <p>{{'Votre mot de passe a ete enregistre avec succes !' | transloco}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-buttons text-center justify-content">
                        <a mat-raised-button
                           color="primary"
                           [href]="'https://api.pub2.infomaniak.cloud/horizon/auth/logout'">
                            {{ ('Tableau de bord OpenStack' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngSwitchCase="'outdated'"
         class="step-outdated container padding-top-60 padding-bottom-60">
        <mat-card class="card shadow">
            <mat-card-content>
                <div class="block-summary padding-top-40 padding-bottom-40">
                    <div class="block-summary__header">
                        <div class="text-center block">
                            <div class="margin-bottom-40">
                                <span class="icon icon-warning icon-size-120 color-grey-darken-1"></span>
                            </div>
                            <div class="row justify-content-sm-center">
                                <div class="col-lg-8">
                                    <p>{{'Ce lien n\'est pas valide ou a deja ete utilise. Pour des raisons de securite, veuillez renvoyer une demande de creation de mot de passe depuis le Manager.' | transloco}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</ng-container>